<ng-template #vc></ng-template>
<ng-content></ng-content>